import { useMemo, useState } from 'react';
import { Badge, Divider, LoadingText, MenuItem, Row, Searchbox, Typography } from 'seagull';
import styles from "./AddServicesPopover.module.scss";
import { CreateNewButton } from "../../CreateNewButton/CreateNewButton";
import { Intent } from "../../../infra/access-control";
import { serviceCostModel, serviceTemplateModel } from "../../../models";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function filterServiceTemplates(_ref) {
  let {
    serviceTemplates,
    search
  } = _ref;
  const lowercaseSearch = search.toLowerCase();
  return serviceTemplates ? serviceTemplates.filter(serviceTemplate => serviceTemplate.name.toLowerCase().includes(lowercaseSearch)) : [];
}
export function AddServicesPopover(_ref2) {
  let {
    testId,
    isLoading,
    serviceTemplates,
    onServiceTemplateSelected,
    onCreateNew
  } = _ref2;
  const [search, setSearch] = useState('');
  const filtered = useMemo(() => filterServiceTemplates({
    serviceTemplates,
    search
  }), [serviceTemplates, search]);
  function renderServiceTemplate(s) {
    const isBundle = serviceTemplateModel.isBundle(s);
    const subtextFirstPart = isBundle ? serviceTemplateModel.formatNumIncludedServices(s) : serviceCostModel.stringifyServiceCost(s.cost).costDisplay;
    const subtextSecondPart = serviceTemplateModel.formatExtendedRecurrencePeriod(s);
    return /*#__PURE__*/_jsxs(MenuItem, {
      variant: "multiline",
      onClick: () => onServiceTemplateSelected(s),
      children: [/*#__PURE__*/_jsxs(Row, {
        gap: 4,
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Typography, {
          ellipsis: true,
          weight: "normal",
          skin: "secondary",
          children: s.name
        }), isBundle && /*#__PURE__*/_jsx(Badge, {
          outlined: true,
          rounded: true,
          skin: "primary",
          children: "Bundle"
        })]
      }), /*#__PURE__*/_jsxs(Typography, {
        skin: "secondary",
        children: [subtextFirstPart, " \u2022 ", subtextSecondPart]
      })]
    }, s.id);
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles.popover,
    "data-testid": "".concat(testId, "-popover"),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.searchSection,
      children: /*#__PURE__*/_jsx(Searchbox, {
        variant: "textfield",
        fluidWidth: true,
        value: search,
        onChange: e => setSearch(e.target.value),
        onClear: () => setSearch('')
      })
    }), /*#__PURE__*/_jsx("ul", {
      className: styles.servicesSection,
      children: isLoading ? /*#__PURE__*/_jsx("li", {
        className: styles.horizPaddingOnly,
        children: /*#__PURE__*/_jsx(LoadingText, {})
      }) : filtered.length > 0 ? filtered.map(renderServiceTemplate) : /*#__PURE__*/_jsx("li", {
        className: styles.horizPaddingOnly,
        children: /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          children: "No matches found. Try again or create a new service."
        })
      })
    }), /*#__PURE__*/_jsx(Divider, {
      margin: 0
    }), /*#__PURE__*/_jsx("div", {
      className: styles.bottomSection,
      children: /*#__PURE__*/_jsx(CreateNewButton, {
        intent: Intent.CreateServiceTemplate,
        onClick: onCreateNew
      })
    })]
  });
}